import classNames from 'classnames'
import { useState } from 'react'
import './SortMenu.scoped.sass'

export function SortMenu (props) {
  const {
    sortValues = [],
    selectSortType = () => {},
    selectedSortType = 'Newest first',
    title = false,
    noTitle = false,
    right = false,
  } = props

  const [checked, setChecked] = useState(false)
  const [currentSelected, setCurrentSelected] = useState(selectedSortType)
  const handleChange = () => {
    setChecked(!checked)
  }

  const onSelectSortType = (sortType) => {
    setChecked(!checked)
    setCurrentSelected(sortType)
    selectSortType(sortType)
  }

  return <div className="menu-dropdown">
    <div className="dropdown-selector">
      { !noTitle && <label>{ title || 'Sort by: '}</label>} &nbsp; <span className='current-selected'>{currentSelected}</span>
      <input type="checkbox" checked={checked} onChange={handleChange} />
      <div className='options-container'>
        <ul className={classNames('dropdown-choices', {
          right: right
        })}>
          {sortValues
            .map((sortType, index) =>
              <li key={index} className={currentSelected === sortType ? 'active' : ''} onClick={() => onSelectSortType(sortType)}>{sortType}</li>
            )
          }
        </ul>
      </div>
    </div>
  </div>
}
